// extracted by mini-css-extract-plugin
export default {"customChart":"DashboardPage_customChart__AjaCJ","chart1Wrapper":"DashboardPage_chart1Wrapper__0t2f0"};